interface EmployeeData {
  name: string;
  job: string;
  nationalId: string;
  address: string;
}

export const generatePersonnelPreviewHTML = (
  employeeData: EmployeeData[],
  branchName: string
): string => {
  const todayAr = new Date().toLocaleDateString('ar-EG');

  return `<div dir="rtl" style="font-family: 'Arial', 'Tahoma', sans-serif; text-align: right; line-height: 2;">
      <p style="text-align: left; margin-bottom: 20px;">تاريخ: ${todayAr}</p>

      <p style="font-weight: bold; margin-bottom: 15px;">السيد/ قائد مكتب مخابرات حرس حدود – ${branchName}</p>

      <p style="margin-bottom: 5px;">تحية طيبة وبعد ،،،</p>

      <p style="margin-bottom: 15px;">يرجى من سيادتكم التكرم بعمل اللازم نحو استخراج تصاريح حرس الحدود للوحدة ${branchName} للافراد الاتي بياناتهم:</p>

      <table style="width: 100%; border-collapse: collapse; margin: 15px 0; direction: rtl;" border="1" cellpadding="8" cellspacing="0">
        <thead>
          <tr style="background-color: #e0e0e0;">
            <th style="border: 1px solid #000; padding: 8px; text-align: center;">م</th>
            <th style="border: 1px solid #000; padding: 8px; text-align: center;">الاسم</th>
            <th style="border: 1px solid #000; padding: 8px; text-align: center;">الوظيفة</th>
            <th style="border: 1px solid #000; padding: 8px; text-align: center;">الرقم القومي</th>
            <th style="border: 1px solid #000; padding: 8px; text-align: center;">العنوان</th>
          </tr>
        </thead>
        <tbody>
          ${employeeData.map((emp, index) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px; text-align: center;">${index + 1}</td>
              <td style="border: 1px solid #000; padding: 8px; text-align: center;">${emp.name}</td>
              <td style="border: 1px solid #000; padding: 8px; text-align: center;">${emp.job}</td>
              <td style="border: 1px solid #000; padding: 8px; text-align: center;">${emp.nationalId}</td>
              <td style="border: 1px solid #000; padding: 8px; text-align: center;">${emp.address}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>

      <p style="margin-top: 20px;">ونحن إذ نشكر حسن تعاونكم المعهود معنا</p>

      <p style="margin-top: 30px; text-align: left;">إدارة الموارد البشرية</p>
    </div>`;
};

export const buildPersonnelPrintHTML = (
  employeeData: EmployeeData[],
  branchName: string
): string => {
  const todayAr = new Date().toLocaleDateString('ar-EG');

  return `<!DOCTYPE html>
<html dir="rtl">
  <head>
    <meta charset="UTF-8">
    <title>تصاريح حرس الحدود - أفراد</title>
    <style>
      @page { margin: 20mm; size: A4; }
      body {
        font-family: 'Arial', 'Tahoma', sans-serif;
        font-size: 14px;
        line-height: 2;
        margin: 0;
        padding: 20px;
        direction: rtl;
        text-align: right;
      }
      .header {
        text-align: center;
        margin-bottom: 20px;
        border-bottom: 2px solid #000;
        padding-bottom: 10px;
      }
      .company-name { font-size: 18px; font-weight: bold; }
      .company-name-ar { font-size: 16px; font-weight: bold; margin-top: 5px; }
      .date { text-align: left; margin-bottom: 20px; }
      .recipient { font-weight: bold; margin-bottom: 15px; }
      table {
        width: 100%;
        border-collapse: collapse;
        margin: 15px 0;
      }
      th, td {
        border: 1px solid #000;
        padding: 8px;
        text-align: center;
      }
      th { background-color: #e0e0e0; font-weight: bold; }
      .footer { margin-top: 30px; }
      .signature { text-align: left; margin-top: 40px; }
      @media print {
        body { padding: 0; }
      }
    </style>
  </head>
  <body>
    <div class="header">
      <div class="company-name">PetroMarine Offshore Projects Support Co.</div>
      <div class="company-name-ar">شركة بترومارين لدعم المشاريع البحرية</div>
    </div>

    <div class="date">تاريخ: ${todayAr}</div>

    <p class="recipient">السيد/ قائد مكتب مخابرات حرس حدود – ${branchName}</p>

    <p>تحية طيبة وبعد ،،،</p>

    <p>يرجى من سيادتكم التكرم بعمل اللازم نحو استخراج تصاريح حرس الحدود للوحدة ${branchName} للافراد الاتي بياناتهم:</p>

    <table>
      <thead>
        <tr>
          <th>م</th>
          <th>الاسم</th>
          <th>الوظيفة</th>
          <th>الرقم القومي</th>
          <th>العنوان</th>
        </tr>
      </thead>
      <tbody>
        ${employeeData.map((emp, index) => `
          <tr>
            <td>${index + 1}</td>
            <td>${emp.name}</td>
            <td>${emp.job}</td>
            <td>${emp.nationalId}</td>
            <td>${emp.address}</td>
          </tr>
        `).join('')}
      </tbody>
    </table>

    <div class="footer">
      <p>ونحن إذ نشكر حسن تعاونكم المعهود معنا</p>
    </div>

    <div class="signature">
      <p>إدارة الموارد البشرية</p>
    </div>
  </body>
</html>`;
};
